import { BreadcrumbItem, Breadcrumbs } from "@nextui-org/react";
import { BaseURL } from "../../config/axios";
import { Link, useLocation } from 'react-router-dom'
import { Helmet } from "react-helmet";

export default function HeroHeader({ header1, header2, seo_title, meta_description, baner, text1, text2, text3, withButton, breadcrumb = [] }) {
  const location = useLocation();
  const canonicalUrl = `${window.location.origin}${location.pathname}`;
  return (
    <>
      <Helmet>
        <title>{seo_title}</title>
        <meta
          name="description"
          content={meta_description}
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <section
        className="container h-[650px] w-full relative bg-left bg-no-repeat bg-cover xl:bg-contain"
        style={{ backgroundImage: `url('${BaseURL + baner[0]?.path}')` }}
        dir="rtl">
        <div className="h-full w-full lg:bg-gradient-to-l bg-gradient-to-b from-white via-white via-[38%] to-transparent to-80%"></div>

        <div className="lg:max-w-[600px] absolute px-6 lg:py-16 pt-16 top-0 w-full lg:bottom-0 lg:h-full flex gap-6 flex-col justify-center md:text-wrap text-justify">
          {!withButton && <Breadcrumbs separator='/' className="absolute lg:top-16 top-6" itemClasses={{ separator: "px-2" }}>
            <BreadcrumbItem href="/">صفحه اصلی</BreadcrumbItem>
            <BreadcrumbItem href={`/${breadcrumb[0]?.slug}`}>{breadcrumb[0]?.name}</BreadcrumbItem>
            {breadcrumb[1]?.name && <BreadcrumbItem>{breadcrumb[1].name}</BreadcrumbItem>}
          </Breadcrumbs>}
          <h1 className="sm:text-3xl text-2xl lg:text-4xl font-bold">{header1}</h1>

          <h2 className="font-normal leading-[1.4em] lg:text-2xl xl:text-gray-500">{header2}</h2>
          {withButton && <Link to='/product?page=1' className="text-white bg-main hover:bg-gradient-to-br  focus:outline-none shadow-lg dark:shadow-lg font-medium rounded-lg text-sm px-8 leading-normal py-2.5 text-center me-2 mb-2 w-fit">شروع کنید</Link>}
          {/* <div className="centerOfParent sm:w-96 w-80 h-fit">
            <img  width={100} height={100} src='/images/yalda1403.png' className='w-full h-full object-contain' />
          </div> */}
        </div>
      </section>

      <section
        dir="rtl"
        className="container grid justify-center lg:grid-cols-3 w-full bg-main py-2 gap-6"
      >
        <div className="flex text-white items-center justify-center gap-2">
          <svg className='text-3xl' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path></svg>
          <p>{text1}</p>
        </div>

        <div className="flex text-white items-center justify-center gap-2">
          <svg className='text-3xl' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path></svg>
          <p>{text2}</p>
        </div>

        <div className="flex text-white items-center justify-center gap-2">
          <svg className='text-3xl' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path></svg>
          <p>{text3}</p>
        </div>
      </section>
    </>
  );
}
